import {
  QUICK_ADD
} from 'permissions/actions'

export const DEAL_LOSS_REASON = '@@permissions/policy/dealLossReason'

export default {
  [QUICK_ADD]: (user, options) => !!user.is_account_admin && !user.read_only
}
